import { render } from "./GlossaryUsageNavigationCard.vue?vue&type=template&id=04ad83a2&scoped=true&ts=true"
import script from "./GlossaryUsageNavigationCard.vue?vue&type=script&lang=ts"
export * from "./GlossaryUsageNavigationCard.vue?vue&type=script&lang=ts"

import "./GlossaryUsageNavigationCard.vue?vue&type=style&index=0&id=04ad83a2&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ad83a2"]])

export default __exports__